const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  warn(msg, ...args) { if (isDev) console.warn(msg, ...args); },
  error(msg, ...args) { if (isDev) console.error(msg, ...args); },
  info(msg, ...args) { if (isDev) console.info(msg, ...args); },
};
